export default "__VITE_ASSET__D7j3ZZ3Q__"